//export const API_URL = 'http://127.0.0.1:8000/api/v1/'; // LOCAL
// export const API_URL = 'https://cosynd-nma-api-dev-aee381795eba.herokuapp.com/api/v1/'; // DEV
// export const API_URL = 'https://cosynd-api-stage.herokuapp.com/api/v1/'; // STAGING
export const API_URL = 'https://mserv.cosynd.com/api/v1/'; // PROD

export const FILEPICKER_KEY = 'A2gD5IiOnToCBWcvtmTOBz';

//export const COSYND_PDF_URL = 'http://127.0.0.1:3001/generate/'; // LOCAL
//export const COSYND_PDF_URL = 'https://cosynd-pdf.herokuapp.com/generate/'; // DEV
export const COSYND_PDF_URL = 'https://pdf.cosynd.com/generate/'; // PROD

// export const PUSHER_APP_KEY = "74ded069980f59d7006f"; // DEV
export const PUSHER_APP_KEY = '2f9d350fb0aea961fd0d'; // PROD
export const PUSHER_CLUSTER = 'us2';

export const PublishesID = 9999;

// export const GOOGLE_RECPATCHA_KEY = '6LeFa7YUAAAAAD1qF0X6JXhWB4vgJtEOQb97HwMY';   // test for localhost
export const GOOGLE_RECPATCHA_KEY = '6LcabbYUAAAAAEsqPGu8BnYPSuabYorqh0hxJugF';

export const BRAINTREE_URL = 'https://www.braintreepayments.com';
export const BRAINTREE_LEGAL_PAGE_URL =
  'https://www.braintreepayments.com/legal';
export const COSYND_CONTACT_PAGE_URL =
  'https://cosynd.zendesk.com/hc/en-us/requests/new';
export const COSYND__GUIDE_URL =
  'https://cosynd.zendesk.com/hc/en-us/sections/115004082228-How-To-Guides';
export const COSYND_TERMS_PRIVACY_LINK = 'https://cosynd.com/policies';
export const COSYND_WORK_FOR_HIRE_URL =
  'https://cosynd.zendesk.com/hc/en-us/articles/115006546748-What-does-Work-for-hire-mean-';

export const COST_SIMPLE = 65;
export const COST_STANDARD = 65;
export const COST_COSYND_ADMIN_FEE = 35;
export const COST_UNPUBLISHED_WORK = 85;
export const COST_PHOTOGRAPH_COLLECTION = 55;
export const COST_UNPUBLISHED_LITERARY_WORK = 85;
export const CREG_LIMIT_FOR_PREMIUM_ANNUAL = 4;

export const COST_SINGLE_AGREEMENT = 35;

export const WORK_SUB_TYPE_MUSICAL_COMPOSITION = '4';
export const WORK_SUB_TYPE_MUSICAL_COMPOSITION_SOUND_RECORDING = '5';
export const WORK_SUB_TYPE_PHOTOGRAPH_INDIVIDUAL = '8';
export const WORK_SUB_TYPE_PHOTOGRAPH_COLLECTION = '9';
export const WORK_SUB_TYPE_LITERARY_WORK = '14';

// Monthly Fee
export const FEDERAL_FILLING_FEE_M = 95;
export const TIER_1M = 100;
export const TIER_2M = 500;
export const TIER_3M = 2500;

// Annual Fee
export const FEDERAL_FILLING_FEE_A = 1140;
export const TIER_1A = 1000;
export const TIER_2A = 5000;
export const TIER_3A = 25000;

export const USStates = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Dist. Columbia',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

export const CADStates = [
  'Alberta',
  'British Columbia',
  'Labrador',
  'Manitoba',
  'New Brunswick',
  'Newfoundland',
  'Nova Scotia',
  'Nunavut',
  'North West Terr.',
  'Ontario',
  'Prince Edward Is.',
  'Quebec',
  'Saskatchewen',
  'Yukon',
];

export const Contributions = {
  Video: [
    'Direction',
    'Production',
    'Script/Screenplay',
    'Entire Motion Picture',
    'Cinematography',
    'Editing',
  ],
  Music: [
    'Lyrics',
    'Sound Recording',
    'Sound Recording + Composition (Lyrics, Music)',
    'Music',
  ],
  Image: [
    'Photograph',
    'Artwork',
    'Jewelry Design',
    'Sculpture',
    'Map',
    'Architectural Work',
    'Technical Drawing',
    '2-D artwork',
  ],
  Document: ['Text', 'Photographs', 'Artwork'],
  'News Media': ['Digital Newspaper', 'Digital Magazine'],
};

export const ContributionServices = {
  Video: [
    'Directorial services',
    'Production services',
    'Writing services',
    'Dramatic/theatrical performance(s)',
    'Editorial services',
  ],
  Music: [
    'Creation of lyrics',
    'Creation of melody',
    'Record production',
    'Production',
    'Instrumental services',
    'Vocal services',
  ],
  Image: [
    'Photography services',
    'Illustration services',
    'Design services',
    'Usage of property as part of work',
    'Modelling services',
  ],
  Document: ['Writing services', 'Editorial services', 'Research services'],
};

export const Materials = {
  Video: {
    Excluded: [
      'Script/Screenplay',
      'Preexisting Music',
      'Preexisting Footage',
      'Preexisting Photograph(s)',
    ],
    Included: [
      'All other cinematographic material',
      'Production as a motion picture',
      'Additional footage',
      'Revisions/additions to script',
    ],
  },
  Music: {
    Excluded: [
      'Sound Recording + Composition (Lyrics, Music)',
      'Sound Recording Only',
      'Music',
      'Lyrics',
      // "Text"
    ],
    Included: [
      'Sound Recording + Composition (Lyrics, Music)',
      'Sound Recording Only',
      'Music',
      'Lyrics',
      // "Text"
    ],
  },
  Image: {
    Excluded: [
      'Photograph',
      'Artwork',
      'Jewelry Design',
      'Sculpture',
      'Map',
      'Architectural Work',
      'Technical Drawing',
      '2-D artwork',
    ],
    Included: [
      'Photograph',
      'Artwork',
      'Jewelry Design',
      'Sculpture',
      'Map',
      'Architectural Work',
      'Technical Drawing',
      '2-D artwork',
    ],
  },
  Document: {
    Excluded: ['Text', 'Artwork', 'Photograph'],
    Included: ['Text', 'Artwork', 'Photograph'],
  },
  'News Media': {
    Excluded: ['Text', 'Artwork', 'Photograph'],
    Included: ['Text', 'Artwork', 'Photograph'],
  },
};

export const CosyndDefaultData = {
  Organization: 'Cosynd',
  Email: 'copyright@cosynd.com',
  Phone: '917-679-2916',
  Address: 'Cosynd+Alley 140 West Street',
  City: 'New York',
  State: 'NY',
  Postal: '10007',
  Country: 'USA',
};

//cdbaby and soundrop are for the premium subscription
export const REFERRER_IDS = [
  'nma',
];



// WEBPACK FOOTER //
// src/constants.js